import gql from "graphql-tag";

export default gql`
  query SitemapIssuerListing($filterByIssuerType: IssuerType!, $skip: Int, $limit: Int) {
    sitemapIssuerListing(filterByIssuerType: $filterByIssuerType, skip: $skip, limit: $limit) {
      nodes {
        issuerId
        issuerType
        tickerSymbol
        resourcePath
        name
        url
      }
      pageInfo {
        hasNextPage
      }
      totalCount
    }
  }
`;
